import React from 'react';

function ProgressRing({ value, size = 42 }) {
  const radius = 16;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - (value / 100) * circumference;

  return (
    <div className="progress-ring" style={{ width: size, height: size }}>
      <svg viewBox="0 0 40 40">
        <circle className="ring-track" cx="20" cy="20" r={radius} />
        <circle
          className="ring-value"
          cx="20"
          cy="20"
          r={radius}
          strokeDasharray={circumference}
          strokeDashoffset={offset}
        />
      </svg>
      <span>{value}</span>
    </div>
  );
}

export default ProgressRing;